export const handleChangePage = (event, newPage, setPage) => {
    setPage(newPage);
};

export const handleChangeRowsPerPage = (event, key, setPage, setRowsPerPage) => {
    const rows = parseInt(event.target.value, 10);
    setRowsPerPage(rows);
    setPage(0); 
    localStorage.setItem(key, rows); 
};